import { styled } from 'solid-styled-components';

export const StyledShortcutMenuIcon = styled.div`
    position: absolute;
    left: -6rem;
`;
